export enum AlignPosition {
  Top = 'top',
  Center = 'center',
  Bottom = 'bottom',
}
